import { Star } from "lucide-react";
import { useState } from "react";
import './stars.css';

export const StarRating = ({ rating, onRatingChange, className = "" }) => {
  const [hoveredRating, setHoveredRating] = useState(0);

  return (
    <div className={`stars-container ${className}`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className="star-button"
          onMouseEnter={() => setHoveredRating(star)}
          onMouseLeave={() => setHoveredRating(0)}
          onClick={() => onRatingChange(star)}
        >
          <Star
            size={28}
            className={`star-icon ${
              star <= (hoveredRating || rating)
                ? "star-active"
                : "star-inactive"
            }`}
          />
        </button>
      ))}
    </div>
  );
}